import { Box } from '@mui/material';
import Scrollbars from 'react-scrollbars-custom';

import FlippableCard from './FlippableCard';

const styles = {
  scrollbars: {
    width: '100%',
    height: '340px',
    marginBottom: '48px',
  },
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    width: '100%',
    boxSizing: 'border-box',
  },
};

const Cards = props => {
  const {
    data = [],
    name = 'name',
    image,
    color,
    sub,
    desc,
    icons,
    flipper = true,
  } = props;

  const trackProps = {
    style: {
      background: 'transparent',
      borderRadius: 0,
    },
  };
  const thumbProps = {
    style: {
      background: '#fff',
      borderRadius: 0,
    },
  };

  const cardProps = { name, image, color, sub, desc, icons };

  return (
    <Scrollbars
      trackXProps={trackProps}
      trackYProps={trackProps}
      thumbXProps={thumbProps}
      thumbYProps={thumbProps}
      permanentTrackX={false}
      permanentTrackY={false}
      style={styles.scrollbars}
    >
      <Box sx={styles.root}>
        {data.map(item => (
            <FlippableCard
              key={item[name]}
              data={item}
              flippable={flipper}
              {...cardProps}
            />
        ))}
      </Box>
    </Scrollbars>
  );
};

export default Cards;
